export default "__VITE_ASSET__DbB0cTGx__"